module.exports = __webpack_public_path__ + "static/media/organizator.8c4b7b62.jpg";